/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MediaList_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DualSearchMediaList_offer$ref: FragmentReference;
declare export opaque type DualSearchMediaList_offer$fragmentType: DualSearchMediaList_offer$ref;
export type DualSearchMediaList_offer = {|
  +$fragmentRefs: MediaList_offer$ref,
  +$refType: DualSearchMediaList_offer$ref,
|};
export type DualSearchMediaList_offer$data = DualSearchMediaList_offer;
export type DualSearchMediaList_offer$key = {
  +$data?: DualSearchMediaList_offer$data,
  +$fragmentRefs: DualSearchMediaList_offer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DualSearchMediaList_offer",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "MediaList_offer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'da634a1a51c99e2e039b99a6f936591b';

module.exports = node;
